module.exports = __webpack_public_path__ + "static/Lora-Medium-c3e2f11036e070e9ea5a4cc2c1169165.ttf";